import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Button } from "theme-ui";
import { updateComment } from "../../../store/actions/frontApp.Action";
import toast from "react-hot-toast";


interface CommentProps {
    original: any,
    colorMode: string
}
const CommentBox: React.FC<CommentProps> = ({ original, colorMode }) => {
    const [Isopen, setIsopen] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [comment, setComment] = useState(original?.client_comment);
    const dispatch = useDispatch();
    const [focusedField, setFocusedField] = useState<string | null>(null);
    const inputRef = useRef<HTMLTextAreaElement>(null);

    React.useEffect(() => {
        setComment(original?.client_comment);
    }, [original?.client_comment]);
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";

    useEffect(() => {
        setComment(original?.client_comment);
    }, [original?.client_comment]);

    const commentValue = original?.client_comment;
    const truncatedComment = commentValue?.length > 15 ? commentValue.slice(0, 15) + '' : commentValue;

    const handleClick = () => {
        if (commentValue?.length > 15 && !expanded) {
            setExpanded(true);
        } else {
            handleOpen();
        }
    };

    const handleOpen = () => {
        if (original?.timer?.isRunning) {
            toast.error("Please pause the timer to update the comment.");
            return;
        }
        setIsopen(true);
        setFocusedField('comment');
    };
    const handleClose = () => {
        setIsopen(false)
        setExpanded(false);
        setFocusedField(null);
    }
    const handleSave = () => {
        if (original?.timer?.isRunning) {
            toast.error("Please pause the timer");
            return;
        }
        const payload = {
            client_comment: comment
        }
        dispatch(updateComment(payload, original?.comment_id));
        setIsopen(false);
        setExpanded(false);
        setFocusedField(null);
    }
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={handleClose}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    return (
        <>
            {original?.client_comment ? (
                <p onClick={handleClick} style={{ cursor: 'pointer' }}>
                    {expanded || commentValue?.length <= 15 ? commentValue : truncatedComment}
                    {commentValue?.length > 15 && !expanded && <span style={{ color: '#007FFF', marginLeft: '2px' }}>...</span>}
                </p>
            ) : (
                <textarea className="form-control" onClick={handleOpen} />
            )}

            <Modal isOpen={Isopen} onOpened={() => inputRef.current?.focus()}>
                <ModalHeader aria-rowcount={12} aria-atomic={"true"} toggle={handleClose} close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    Comment Box
                </ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <p style={{ color: titleHeader }}>Update info</p>
                    <Input
                        innerRef={inputRef}
                        placeholder="Enter Comment"
                        className="form-control"
                        name="comment"
                        type="textarea"
                        rows={5}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        autoFocus={!focusedField || focusedField === 'comment'}
                    />
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    {/* <Button variant="CancelButton" onClick={handleCloss}>Cancel</Button> */}
                    <Button variant="SaveButton" onClick={handleSave}>Save</Button>
                </ModalFooter>
            </Modal>
        </>

    )
}
export default CommentBox;
